import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel
} from '@headlessui/react';
import { Check, Copy } from 'lucide-react';
import { ReactNode, useState } from 'react';
import { MdOutlineKeyboardArrowUp } from 'react-icons/md';

const Accordion = ({
  title,
  children,
  onToggle,
  isOpen,
  defaultOpen,
  width = 'w-[70%]'
}: {
  title: string | ReactNode;
  children: ReactNode;
  onToggle?: any;
  isOpen: boolean;
  defaultOpen?: boolean;
  width?: string;
}) => {
  const [copiedCode, setCopiedCode] = useState<string | null>(null);
  const copyToClipboard = (question: any) => {
    navigator.clipboard.writeText(question);
    setCopiedCode(question);
    setTimeout(() => {
      setCopiedCode(null);
    }, 2000);
  };

  return (
    <div className={`${width} rounded-[12px] border border-[#E3E5E9]`}>
      <div className='w-full rounded-2xl bg-white'>
        <Disclosure defaultOpen={defaultOpen}>
          {({ open: isOpen }) => (
            <>
              <DisclosureButton
                className={` ${isOpen ? 'rounded-t-xl ' : 'rounded-xl'} flex w-full justify-between bg-[#F8F9FA] px-4 py-2 text-left text-base font-medium text-black hover:bg-[#F1F7E2] focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75`}
                onClick={onToggle}
              >
                <span className='font-medium'>{title}</span>
                <div className='flex flex-row gap-2'>
                  <button
                    className='z-50 self-start'
                    onClick={e => {
                      e.stopPropagation();
                      copyToClipboard(title);
                    }}
                  >
                    {copiedCode ? (
                      <Check className='h-5 w-5 text-green-600' />
                    ) : (
                      <Copy className='h-5 w-5 text-gray-600 hover:text-purple-600' />
                    )}
                  </button>
                  <MdOutlineKeyboardArrowUp
                    className={`${
                      isOpen ? 'rotate-180 transform' : ''
                    } h-5 w-5 flex-shrink-0 text-purple-500`}
                  />
                </div>
              </DisclosureButton>
              <DisclosurePanel className='px-4 pb-2 pt-4 text-base text-gray-500'>
                {children}
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  );
};

export default Accordion;
